module.exports = __webpack_public_path__ + "img/jjr.3efc3548.png";